import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Subscription } from 'rxjs/Subscription';
import { SetupService } from '../../../services/setup/setup.service';
import { NavHelperService } from '../../../services/nav/nav-helper.service';
import { LockedDayService } from '../../../services/locked-day/locked-day.service';

@IonicPage()
@Component({
  selector: 'page-nav-root',
  templateUrl: 'nav-root.html',
})
export class NavRootPage {
  @ViewChild('content') nav: NavController;
  @ViewChild('menuContent') menuNav: NavController;

  sidebarCollapsed: boolean;
  private subscriptions: Subscription[] = [];
  private destroyed = false;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public setupService: SetupService,
              public navHelperService: NavHelperService,
              public lockedDayService: LockedDayService) {
    this.subscriptions.push(this.navHelperService.currentSidebarCollapsed.subscribe(sidebarCollapsed => {
      this.sidebarCollapsed = sidebarCollapsed;
    }));
  }

  ionViewDidLoad() {
    this.subscriptions.push(this.navHelperService.currentNavPage.subscribe(navPage => {
      this.setRootSafely(this.nav, navPage);
    }));

    this.subscriptions.push(this.navHelperService.currentNavMenuPage.subscribe(navPage => {
      // This stream also supplies the initial menu; a template root would create it twice.
      this.setRootSafely(this.menuNav, navPage);
    }));
  }

  ionViewWillUnload() {
    this.cleanupSubscriptions();
  }

  ngOnDestroy() {
    this.cleanupSubscriptions();
  }

  private setRootSafely(targetNav: NavController, navPage: any) {
    if (this.destroyed || !targetNav || !navPage || !navPage.page) {
      return;
    }

    const type = navPage.params ? navPage.params['type'] : null;

    if (type != null) {
      targetNav.setRoot(navPage.page, {type: type});
    } else {
      targetNav.setRoot(navPage.page);
    }
  }

  private cleanupSubscriptions() {
    if (this.destroyed) {
      return;
    }

    this.destroyed = true;
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.subscriptions = [];
  }
}



// WEBPACK FOOTER //
// ./src/pages/nav/nav-root/nav-root.ts